import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { MenuItem } from '@headlessui/react';
import { useContext } from 'react';
import { isRtl, LocaleContext } from '../../../i18n/src';
import { Icon } from '../../../icon/src';
import { DROPDOWN_ITEM_ID_ATTRIBUTE } from './dropdown.constants';
export const DropdownMenuItem = ({ closeDropdown, isInline, isSheet = false, item, onDrillInto, }) => {
    var _a;
    const locale = useContext(LocaleContext);
    const isBranch = Boolean(item.children);
    const handleClick = (event) => {
        // Headless UI stops merging click handlers as soon as one prevents the default, which is how a branch keeps the
        // menu open instead of letting the item close it.
        if (item.children) {
            event.preventDefault();
            onDrillInto(item);
            return;
        }
        if (item.readonly) {
            event.preventDefault();
            return;
        }
        item.onClick({ event, item, closeDropdown });
    };
    return (_jsx(MenuItem, { disabled: item.disabled, children: _jsxs("div", { [DROPDOWN_ITEM_ID_ATTRIBUTE]: item.id, "aria-current": item.selected ? 'true' : undefined, "aria-haspopup": isBranch ? 'menu' : undefined, className: `nucleus-box-border nucleus-flex nucleus-items-center nucleus-font-sans ${isSheet
                ? 'nucleus-mx-2 nucleus-my-0.5 nucleus-gap-3 nucleus-rounded-xl nucleus-px-3 nucleus-py-2.5'
                : isInline
                    ? 'nucleus-gap-1 nucleus-px-2 nucleus-py-1'
                    : 'nucleus-px-4 nucleus-py-1.5'} ui-disabled:nucleus-cursor-not-allowed ui-disabled:nucleus-bg-neutral-200 ui-disabled:nucleus-text-text-disabled
        ${!item.readonly && !item.selected ? 'nucleus-cursor-pointer hover:nucleus-bg-neutral-200 dark:hover:nucleus-bg-neutral-300 ui-active:nucleus-bg-neutral-200 dark:ui-active:nucleus-bg-neutral-300' : ''}
        ${!item.readonly && item.selected ? 'nucleus-cursor-pointer hover:nucleus-bg-primary-100 dark:hover:nucleus-bg-primary-800 ui-active:nucleus-bg-primary-100 dark:ui-active:nucleus-bg-primary-800' : ''}
        ${item.selected ? 'nucleus-bg-primary-100 dark:nucleus-bg-primary-800' : ''}
        ${item.destructive ? 'nucleus-text-text-error' : 'nucleus-text-text-primary'}
        ${(_a = item.className) !== null && _a !== void 0 ? _a : ''}
        `, onClick: handleClick, children: [item.content, isBranch && (_jsx("span", { className: 'nucleus-ml-auto nucleus-flex nucleus-items-center nucleus-pl-2', children: _jsx(Icon, { name: isRtl(locale) ? 'chevronLeft' : 'chevronRight', color: 'current', size: 'sm' }) }))] }) }));
};
//# sourceMappingURL=dropdown_menu_item.component.js.map